runOnLoad "SeedLists", ["destroy"], ->
  new Concerns.Destroy